import withRouter from "hoc/withRouter";
import {
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import wagonsService from "services/admin/wagonsService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const OWNERSHIP_LABELS: Record<string, string> = {
  own: "Собственный",
  rented: "Арендованный",
};

const WagonList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const {
    data: wagonsResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["wagons", { orgID }],
    queryFn: async () => {
      const response: any = await wagonsService.getAll();
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить вагон?")) return;
    await wagonsService.delete(id);
    refetch();
  };

  const num = (n: any) => Number(n || 0).toLocaleString("ru-RU");

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress />
        </div>
      );
    }
    const rows: any[] = (wagonsResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>Вагоны отсутствуют. Чтобы добавить вагон, нажмите на кнопку "Добавить" сверху</div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Номер</TableCell>
            <TableCell>Тип</TableCell>
            <TableCell align="right">Грузоподъёмность, кг</TableCell>
            <TableCell>Владение</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.number}</TableCell>
              <TableCell>{c.type}</TableCell>
              <TableCell align="right">{num(c.capacityKg)}</TableCell>
              <TableCell>{OWNERSHIP_LABELS[c.ownership] || c.ownership}</TableCell>
              <TableCell>
                {c.isActive ? (
                  <Chip size="small" color="success" label="Активен" />
                ) : (
                  <Chip size="small" label="Неактивен" />
                )}
              </TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/baggages/wagons/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <ListPage pageTitle="Парк вагонов" pathToAdd={`/admin/baggages/wagons/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(WagonList);
